import { render, staticRenderFns } from "./CurrentPower.vue?vue&type=template&id=e28bd83a&scoped=true&"
import script from "./CurrentPower.vue?vue&type=script&lang=js&"
export * from "./CurrentPower.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPower.vue?vue&type=style&index=0&id=e28bd83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28bd83a",
  null
  
)

export default component.exports